import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { Clock, ArrowUpRight } from "lucide-react";
import { Badge } from "@/components/ui/badge";

const ArticleCard = ({ article, index = 0 }) => {
  return (
    <motion.article
      initial={{ opacity: 0, y: 24 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, margin: "-40px" }}
      transition={{ duration: 0.5, delay: Math.min(index * 0.06, 0.4) }}
      className="group card-lift bg-white border border-border rounded-xl overflow-hidden flex flex-col"
      data-testid={`article-card-${article.slug}`}
    >
      <Link to={`/articles/${article.slug}`} className="block overflow-hidden">
        <div className="aspect-[16/10] overflow-hidden bg-secondary">
          {article.cover_image && (
            <img src={article.cover_image} alt={article.title} loading="lazy"
              className="h-full w-full object-cover transition-transform duration-500 group-hover:scale-105" />
          )}
        </div>
      </Link>
      <div className="p-6 flex flex-col flex-1">
        <div className="flex items-center gap-3 mb-3">
          <Badge className="bg-navy text-white hover:bg-navy rounded-full text-[11px]">{article.category}</Badge>
          <span className="flex items-center gap-1 text-xs text-muted-foreground">
            <Clock className="h-3 w-3" /> {article.read_minutes} min
          </span>
        </div>
        <Link to={`/articles/${article.slug}`}>
          <h3 className="font-display text-lg font-bold text-navy leading-snug group-hover:text-electric transition-colors">
            {article.title}
          </h3>
        </Link>
        <p className="mt-2 text-sm text-muted-foreground line-clamp-3 flex-1">{article.excerpt}</p>
        <div className="mt-5 pt-4 border-t border-border/70 flex items-center justify-between">
          <span className="text-xs font-medium text-navy/70">{article.author}</span>
          <Link to={`/articles/${article.slug}`}
            className="flex items-center gap-1 text-xs font-semibold text-electric"
            data-testid={`read-article-${article.slug}`}>
            Read <ArrowUpRight className="h-3.5 w-3.5" />
          </Link>
        </div>
      </div>
    </motion.article>
  );
};

export default ArticleCard;
